import { render, staticRenderFns } from "./ReferralCode.vue?vue&type=template&id=592acf54&scoped=true"
import script from "./ReferralCode.vue?vue&type=script&lang=js"
export * from "./ReferralCode.vue?vue&type=script&lang=js"
import style0 from "./ReferralCode.vue?vue&type=style&index=0&id=592acf54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592acf54",
  null
  
)

export default component.exports